import React from 'react';
import SarasMenu from '../../repeater/menu/SarasMenu'
import SarasFormMenuRow from '../../repeater/menu/SarasFormMenuRow'
import ActionButton from '../../input/buttons/button/SarasButton'

const FormImportLink = (props) => {
    const { formObject, action, headerKey, rowKey, placeHolder, filterKey, style, icon, className, ...restProps } = props; //formObject, action, rowKey, 

    const viewData = formObject.getFormRow(rowKey, headerKey)

    // console.log("form Import Link", viewData);

    const getSelectedRow = (value) => {
        if(value){
            // let selectedItem = viewData.rowValues[value];
            // if(!selectedItem)
            let selectedItem = viewData.rowValues[Object.keys(viewData.rowValues)[value]]
            return selectedItem;
        }
    }

    const onButtonClick = (e) => {
        let buttonkey = (e.current || e.currentTarget).getAttribute('buttonkey');
        let selectedItem = viewData.rowValues[buttonkey];

        let actionName = selectedItem.dataList.actionName;
        let dtId = selectedItem.dataList.valLDT;
        let fromdocId = selectedItem.dataList.imdocId;        ;
        sendRequest(actionName, dtId, fromdocId)
    }

    const onMenuSelect = (e, value) => {
        let selectedItem = getSelectedRow(value);

        let actionName = selectedItem.dataList.actionName;
        let dtId = selectedItem.dataList.valLDT;
        let fromdocId = selectedItem.dataList.imdocId;
        sendRequest(actionName, dtId, fromdocId)
    }

    //actionid="import" actionname="invcomp" doctyid="303" ksc="" actionparam=""
    const sendRequest = (actionName, dtId, fromdocId) => {

    // console.log("list item action name", actionName);

        const customAction = { ...action };
        customAction.actionId = "import";
        customAction.actionName = actionName;
        customAction.containerKey= "popup";
        customAction.actionParam = {
            ...customAction.actionParam,imdtId: dtId, imdocId:fromdocId, is:0,
        };
        // console.log("Import Links",customAction);
        if (customAction.actionId) formObject.onFormAction(customAction, rowKey, headerKey);
    }

    const renderMenuTrigger = () => {
        //const MenuIcon = Icon[icon];
        return (
            <ActionButton 
            className={''}
            starIcon={icon ? icon : 'import'}
            text={"Import"}
            {...restProps}  />
        )
    }

    const renderSearchButton = () => {
        let rowValues = viewData.rowValues;

        //this will affect hotel sales, check them once
        // if (filterKey || viewData.RowValuesKeys.length <= actionDirectAccessCount) {
        if (filterKey) {

            let btndata;

            btndata = rowValues[filterKey] || rowValues[Object.keys(rowValues)[filterKey]];

            return (
                <ActionButton onClick={onButtonClick} buttonkey={btndata.key} text={btndata.dataList.label} ksc={btndata.dataList.shortcut} className={className} />
            )
        }
        else {
            return (
                <SarasMenu menuTrigger={renderMenuTrigger()}
                dataList={Object.values(rowValues)} hideTriggerIfNoOptions={1}
                menuItem={SarasFormMenuRow} onSelection={onMenuSelect} />
            )
        }
    }

    if (!viewData)
        return (null)

    // const actionDirectAccessCount = viewData.dataList.actionDirectAccessCount;

    return (
        renderSearchButton()
        // <SarasMenu menuTrigger={renderMenuTrigger()}
        //     dataList={Object.values(viewData.rowValues)} hideTriggerIfNoOptions={1}
        //     menuItem={SarasFormMenuRow} onSelection={onMenuSelect} />
    )
}

export default FormImportLink